/**
 * Animated Text
 *
 * @package elder-research
 */

export default function() {
	const debug = false;
	if (debug) console.log('Animated Text Loaded');

	const blocks = document.querySelectorAll('.see-it-solved__problem');
	const skipButton = document.getElementById('js-ani-txt-skip');

	let current = 0;

	function cycleBlocks() {
		blocks.forEach(function(b) {
			b.classList.remove('--active');
		});
		const activeBlock = blocks[current];
		if (activeBlock) {
			activeBlock.classList.add('--active');
		}

		// Scroll into center view on mobile only
		if (window.innerWidth < 1024) {
			const container = activeBlock.closest('.see-it-solved__problems');
			const containerRect = container.getBoundingClientRect();
			const blockRect = activeBlock.getBoundingClientRect();
			const scrollLeft = container.scrollLeft + (blockRect.left - containerRect.left) - (container.offsetWidth / 2) + (blockRect.width / 2);
			container.scrollTo({ left: scrollLeft, behavior: 'smooth' });
		}

		current = (current + 1) % blocks.length;
	}

	cycleBlocks();
	setInterval(cycleBlocks, 3000);

	if (!skipButton) return;

	// Fixed Skip functionality with correct section detection
	skipButton.addEventListener('click', function() {
		if (debug) console.log('User clicked Skip button');

		var seeItSolved = skipButton.closest('.see-it-solved');
		if (!seeItSolved) return;

		// Traverse up until we find a parent with an ID (which will be the section)
		var parentSection = seeItSolved;
		while (parentSection && !parentSection.id) {
			parentSection = parentSection.parentElement;
		}
		if (!parentSection) return;

		// Now find the next sibling section
		var nextSibling = parentSection.nextElementSibling;
		while (nextSibling && !nextSibling.id) {
			nextSibling = nextSibling.nextElementSibling;
		}

		if (nextSibling) {
			if (debug) console.log('Scrolling to:', nextSibling.id);
			nextSibling.scrollIntoView({ behavior: 'smooth' });
		}
	});
}
